<script>
import { h, resolveComponent } from 'vue';

export default {
  name: 'cSummaryTable',
  data() {
    return {};
  },
  props: {
    items: {
      type: Array,
      default: () => {}
    }
  },
  computed: {},
  methods: {},
  render() {
    const { $theme, items } = this;
    const cLabel = resolveComponent('c-label');
    const summaryRow = items.map((item, idx) => {
      if (!item.hide) {
        return h(
          'div',
          {
            class: {
              'c-summary-table-row': true
            }
          },
          [
            h(
              'div',
              {
                class: {
                  'c-summary-table-row__key': true
                }
              },
              [
                h(
                  cLabel,
                  {
                    weight: 700,
                    size: 13,
                    color: $theme.COLOR.UI.UI02
                  },
                  [item.key]
                )
              ]
            ),

            h(
              'div',
              {
                class: {
                  'c-summary-table-row__value': true
                }
              },
              [
                item.value &&
                  h(
                    cLabel,
                    {
                      size: 13,
                      color: $theme.COLOR.UI.UI02
                    },
                    [item.value]
                  ),
                item.slotName && this.$slots[item.slotName]
              ]
            )
          ]
        );
      }
    });

    return h(
      'div',
      {
        class: {
          'c-summary-table': true
        }
      },
      [summaryRow]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-summary-table {
  &-row {
    display: flex;

    &:nth-of-type(1) {
      border-top: 1px $color--ui-07 solid;
    }

    &:nth-last-of-type(1) {
      border-bottom: 1px $color--ui-07 solid;
    }

    border-bottom: 1px $color--ui-09 solid;

    &__key {
      width: 180px;
      flex: 0 0 180px;
      padding: 10px 16px;
      background-color: $color--ui-10;
    }

    &__value {
      width: calc(100% - 180px);
      flex: 0 0 calc(100% - 180px);
      padding: 10px 16px;
    }
  }
}
</style>
